const locale = {
    en: {
        home: 'Home',
        listing: 'Service and Professional Listing',
    },
    id: {
        home: 'Home',
        listing: 'Listing Jasa dan Profesional',
    },
};

export default locale;
